import { Alert, Link } from 'bold-ui'
import { useAnalytics } from 'hooks/analytics/useAnalytics'

import { LA_PERIODO_SOMENTE_NAO_FINALIZADOS_IN_DAYS } from '../model'

interface ExistemAtendimentosNaoFinalizadosAlertProps {
  atendimentosOuRegistros: 'atendimentos' | 'registros'
  onClickExibirSomenteNaoFinalizados(): void
  onClickManterFiltroAtual(): void
}

export const ExistemAtendimentosNaoFinalizadosAlert = (props: ExistemAtendimentosNaoFinalizadosAlertProps) => {
  const { atendimentosOuRegistros, onClickExibirSomenteNaoFinalizados, onClickManterFiltroAtual } = props
  const { analytics } = useAnalytics()

  const handleOnClickExibirSomenteNaoFinalizados = () => {
    onClickExibirSomenteNaoFinalizados()
    analytics.logEvent('ver_atend_nao_finalizados_msg_LA')
  }

  const handleOnClickManterFiltroAtual = () => {
    onClickManterFiltroAtual()
    analytics.logEvent('ignorar_msg_nao_finalizados_LA')
  }

  return (
    <Alert type='warning' style={{ paddingTop: '0.25rem', paddingBottom: '0.25rem' }}>
      <strong>{atendimentosOuRegistros.capitalize()} não finalizados.</strong> Existem {atendimentosOuRegistros} dos
      últimos {LA_PERIODO_SOMENTE_NAO_FINALIZADOS_IN_DAYS} dias que não foram finalizados. Esses{' '}
      {atendimentosOuRegistros} não serão incluídos no histórico do cidadão ou contabilizados nos relatórios. Você pode
      utilizar o filtro “Ver somente {atendimentosOuRegistros} não finalizados” para visualizá-los e assim poder
      finalizar esses {atendimentosOuRegistros}.
      <Link
        tabIndex={1}
        onClick={handleOnClickExibirSomenteNaoFinalizados}
        style={{ fontSize: 'inherit', marginLeft: '0.5rem' }}
      >
        Ver somente {atendimentosOuRegistros} não finalizados
      </Link>
      <Link tabIndex={1} onClick={handleOnClickManterFiltroAtual} style={{ fontSize: 'inherit', marginLeft: '0.5rem' }}>
        Finalizar esses {atendimentosOuRegistros} depois
      </Link>
    </Alert>
  )
}
